import React from "react";
import {AppFrame} from "@/app/AppFrame";
import {Box, Button, Typography} from "@mui/material";
import {useNavigate} from "react-router-dom";
import {ReportProblemOutlined} from "@mui/icons-material";
import {useTranslation} from "react-i18next";
import {AuthI18N} from "@/translations";
import {AnmeldebestaetigungIcon} from "@/agentur/AgenturIcons";
import {useTheme} from "@mui/material/styles";

export type FinishedPageProps = {
    success: boolean;
    title: string;
    subTitle?: string;
};

export const FinishedPage = ({ success, title, subTitle }: FinishedPageProps) => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const theme = useTheme();
    const handleGoHome = () => {
        navigate("/");
    };

    return (
        <AppFrame>
            <Box
                sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    minHeight: "70vh",
                    textAlign: "center",
                    p: 3
                }}
            >
                <Box sx={{ mb: 4 }}>
                    {success ? (
                        <AnmeldebestaetigungIcon mode={theme.palette.mode} />
                    ) : (
                        <ReportProblemOutlined sx={{ fontSize: "800%" }} color="error" />
                    )}
                </Box>
                <Typography variant="h4" sx={{ mb: 2, fontWeight: "bold" }}>
                    {title}
                </Typography>
                {subTitle && (
                    <Typography variant="body1" sx={{ mb: 4, maxWidth: "500px" }}>
                        {subTitle}
                    </Typography>
                )}
                <Button variant="contained" size="large" onClick={handleGoHome}>
                    {t(AuthI18N.login.action.goToHome)}
                </Button>
            </Box>
        </AppFrame>
    );
};
